export default __webpack_public_path__ + "static/mobile_13-7e636c7237bd0d90449ec59899afeb8b.webp";